export const prioritiesArray = ["Low", "Medium", "High"];
